import styled from "styled-components";
import { DefaultScrollSize, NavbarHeight } from "../../styles/variables";

export const HeroContainer = styled.section`
  position: relative;
  height: calc(100vh - ${NavbarHeight});
  margin-top:${NavbarHeight};
  width: 100vw;
  margin-left: calc(-50vw + 50% - ${DefaultScrollSize}); 
  display: flex;
  align-items: center;
  color: white;
  overflow: hidden;
      @media(max-width:${({ theme }) => theme.breakpoints.xs}){
  margin-left: calc(-50vw + 50%); 
     
      }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1366px;
  width:100%;
  margin: 0 auto;

`;
